import { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import BackgroundPattern from '../../components/backrounds/BackgroundPattern';
import { TextWithCrowns } from '../../components/TextWithCrown/TextWithCrown';
import { CONTACT_SUPPORT_URL } from '../../config/constants';
import { useHideLoader } from '../../hooks/useHideLoader';

import classes from './Maintenance.module.scss';
import { SvgLogo } from './SvgLogo';

const VITE_PACMAN_URL = import.meta.env.VITE_PACMAN_URL;

export default function MaintenancePage() {
  useHideLoader();
  const { t } = useTranslation();

  const [isRunning, setIsRunning] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (event.data === 'start') {
        setIsRunning(true);
      }
    });
  }, []);

  useEffect(() => {
    if (isRunning) {
      iframeRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [isRunning]);

  return (
    <BackgroundPattern color="violet">
      <div className={classes.maintenance}>
        <div className={classes.head}>
          <SvgLogo className={classes.logo} />
          <div className={classes.title}>{t('maintenance.underMaintenance')}</div>
          <div className={classes.subTitle}>
            <div>{t('maintenance.improvingExperience')}</div>
            <div className={classes.bold}>{t('maintenance.backShortly')}</div>
          </div>
          <div className={classes.textWithCrowns}>
            <TextWithCrowns crownLetters={['o']} text={t('maintenance.playWithCrownMan')} />
          </div>
        </div>
        <iframe
          ref={iframeRef}
          className={classNames(classes.gameIframe, isRunning && classes.running)}
          src={VITE_PACMAN_URL}
        />
        <div className={classes.footer}>
          <div>
            <span>{t('maintenance.pleaseContact')}</span>
            &nbsp;
            <a className={classes.underlineGreen} href={CONTACT_SUPPORT_URL} rel="noreferrer" target="_blank">
              {t('common.contactSupport')}
            </a>
            &nbsp;
            <span>{t('maintenance.forAny')}</span>
          </div>
          <div>
            <span>{t('maintenance.additionalQuestions')}</span>
          </div>
          <div>
            <span>{t('maintenance.kindRegards')}</span>
          </div>
        </div>
      </div>
    </BackgroundPattern>
  );
}
